import React from 'react'
import styled from 'styled-components'

const ErrorMessage = styled.p`
  color: ${props => props.theme.colors.error};
  font-weight: 600;
`

export default ({ error }) => <ErrorMessage>{error}</ErrorMessage>
